import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../slice/authSlice';
import { clearUser } from '../slice/userSlice';
import showToast from '../components/Hot-Toast/showToast.js';
import { useTQuery } from '../utils/useTQuery';

export const useUserStatusCheck = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state.user);
    const { isAuthenticated } = useSelector(state => state.auth);

    const handleLogout = useCallback((message = "Your account has been deactivated. Please contact administrator.") => {
        dispatch(logout());
        dispatch(clearUser());
        localStorage.clear();
        sessionStorage.clear();
        showToast("error", message, 5000);
        navigate('/login');
    }, [dispatch, navigate]);

    // Check user status every 30 seconds if authenticated
    const { data: userStatus } = useTQuery(
        ['userStatus', userDetails?.ID],
        userDetails?.ID ? `/mu/userMangeByID?ID=${userDetails.ID}` : null,
        'get',
        null,
        !!userDetails?.ID && isAuthenticated,
        30000 // Check every 30 seconds
    );

    useEffect(() => {
        if (userStatus && userStatus.OUTPUT && userStatus.OUTPUT.length > 0) {
            const user = userStatus.OUTPUT[0];
            if (user.USER_STATUS === 'Inactive') {
                handleLogout();
            }
        }
    }, [userStatus, handleLogout]);

    // Listen for deactivation events from API errors
    useEffect(() => {
        const handleUserDeactivated = (event) => {
            handleLogout(event.detail.message);
        };

        window.addEventListener('userDeactivated', handleUserDeactivated);

        return () => {
            window.removeEventListener('userDeactivated', handleUserDeactivated);
        };
    }, [handleLogout]);

    return { handleLogout };
};